import * as angular from 'angular';

(function () {
    // https://github.com/textAngular/textAngular/issues/1608
    if (!angular.lowercase) angular.lowercase = function(str){return angular.isString(str) ? str.toLowerCase() : str;};
})();